import { Context, Plugin } from '@nuxt/types';

const consolePlugin: Plugin = (context: Context, inject) => {
  inject('console', {
    ...console
  });
};

export default consolePlugin;
